module.exports = __webpack_public_path__ + "static/Blob2-726e673915cf9e8ee21a311dee5c4cd5.png";